import { backgroundFileUrl } from '@/entities/background'
import type { BackgroundOption } from '@/shared/lib/livekit'
import type { BackgroundSelection } from '../model/background-store'

// Персистится id картинки; для процессора нужен same-origin URL файла.
export function toBackgroundOption(selection: BackgroundSelection): BackgroundOption {
  switch (selection.kind) {
    case 'blur':
      return { type: 'blur' }
    case 'image':
      return { type: 'image', imageUrl: backgroundFileUrl(selection.imageId) }
    default:
      return { type: 'none' }
  }
}
